export default __webpack_public_path__ + "static/media/patient.15761e7c.jpg";